import useSelector from '../../../infrastructure/useSelector';
import { shallowEqual } from 'react-redux';
import * as Apollo from '@apollo/client';

import { GetIntegrationsQuery, GetIntegrationsQueryVariables, useGetIntegrationsQuery } from '../../../../generated/apollo-hooks';

export const useIntegrations = (baseOptions?: Apollo.QueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>) => {
    const { systemId, authorized, supportedSystemType } = useSelector(
        state => ({
            systemId: state.common.currentSystem,
            authorized: state.common.authorized,
            supportedSystemType: state.common.supportedSystemType
        }),
        shallowEqual
    );

    const skip = !(authorized && supportedSystemType && systemId);

    const { data, ...rest } = useGetIntegrationsQuery({ skip, variables: { systemId, realtime: true }, ...baseOptions });

    return { integrations: data?.getIntegrations?.integrations, ...rest };
};
